import React from 'react';
import { CpuIcon } from 'lucide-react';
export function Hero() {
  return <section className="py-20 md:py-32 bg-cover bg-center bg-no-repeat relative" style={{
    backgroundImage: "url('https://cdn.magicpatterns.com/uploads/eZe5KP5Y5rzCLtxrKSp5bw/embed.png')"
  }} data-id="element-483">
      <div className="absolute inset-0 bg-gradient-to-b from-header/40 via-primary/30 to-primary/50" data-id="element-484"></div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-485">
        <div className="text-center" data-id="element-486">
          <div className="w-16 h-16 bg-white/10 border border-white/20 backdrop-blur-sm rounded-xl flex items-center justify-center mx-auto mb-6 load-fade-in-up stagger-1" data-id="element-487">
            <CpuIcon className="w-8 h-8 text-white" data-id="element-488" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 load-fade-in-up stagger-2" data-id="element-489">
            Embedded Systems & Industrial Software
          </h1>
          <p className="text-xl text-blue-200 leading-relaxed load-fade-in-up stagger-3" data-id="element-490">
            We develop software for embedded systems, industrial equipment, and
            specialized hardware applications. Our team has experience with
            low-level programming, hardware interfaces, and real-time operating
            systems.
          </p>
        </div>
      </div>
    </section>;
}